module.exports = __webpack_public_path__ + "img/0.696063a4.png";